import React from "react"

export const StarIcon = (props) => (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fill="#FFC700"
      d="M10.033 7.195a.383.383 0 0 0 .083.383l1.938 2.078a.379.379 0 0 1-.282.637l-2.825-.061a.375.375 0 0 0-.338.195l-1.36 2.477a.379.379 0 0 1-.692-.074l-.83-2.717a.382.382 0 0 0-.291-.264l-2.778-.545a.378.378 0 0 1-.147-.683l2.314-1.617a.378.378 0 0 0 .158-.357L4.625 3.83a.378.378 0 0 1 .601-.347l2.26 1.718a.378.378 0 0 0 .39.042l2.556-1.195a.378.378 0 0 1 .518.469l-.917 2.678Z"
    />
    <path
      fill="#304886"
      d="M11.097 3.829a.757.757 0 0 0-.826-.124L7.718 4.899 5.455 3.182a.754.754 0 0 0-1.205.697l.358 2.816-2.313 1.617a.757.757 0 0 0 .29 1.364l2.78.548.83 2.717a.757.757 0 0 0 1.387.147l1.355-2.476 2.826.061A.757.757 0 0 0 12.33 9.4l-1.94-2.08.917-2.679a.758.758 0 0 0-.21-.811Zm-.505.564-.917 2.679a.757.757 0 0 0 .164.763l1.941 2.081-2.824-.062a.752.752 0 0 0-.678.392L6.923 12.72l-.835-2.718a.756.756 0 0 0-.58-.524l-2.777-.544a.018.018 0 0 1-.002-.004L5.04 7.316a.757.757 0 0 0 .317-.715L5 3.787l2.257 1.716a.757.757 0 0 0 .778.084l2.556-1.195.002.002h-.002Z"
    />
  </svg>
)
